import { Link } from 'react-router-dom';
import Header from './home/components/Header';
import Footer from './home/components/Footer';
import QuoteForm from './home/components/QuoteForm';
import FloatingWhatsApp from './home/components/FloatingWhatsApp';
import PageMeta from '../components/PageMeta';
import { handlePhoneClick } from '../utils/trackPhoneCall';
import { siteConfig } from '../config/site';
import { zonas } from '../data/zonas';
import { climatizacaoServicesList } from '../data/climatizacaoServices';

/** Hub que liga a todas as páginas de zona. */
const Zonas = () => {
  const cityName = siteConfig.address.city;
  const concelhos = zonas.filter((z) => z.tipo === 'concelho');
  const freguesias = zonas.filter((z) => z.tipo === 'freguesia');

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: `Zonas atendidas pela ${siteConfig.name}`,
    itemListElement: zonas.map((zona, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: `Ar Condicionado ${zona.preposicao} ${zona.nome}`,
      url: `https://www.${siteConfig.domain}/ar-condicionado-${zona.slug}`
    }))
  };

  const Grupo = ({ titulo, lista }: { titulo: string; lista: typeof zonas }) => (
    <div className="mb-12">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">{titulo}</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {lista.map((zona) => (
          <div key={zona.slug} className="bg-white rounded-2xl border border-gray-200 p-6 hover:shadow-lg transition-shadow">
            <Link to={`/ar-condicionado-${zona.slug}`} className="group">
              <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-700 transition-colors mb-2">
                Ar Condicionado {zona.preposicao} {zona.nome}
              </h3>
            </Link>
            <p className="text-sm text-gray-600 mb-4">{zona.bairros.slice(0, 5).join(' · ')}</p>
            <div className="flex flex-wrap gap-2">
              {climatizacaoServicesList.map((servico) => (
                <Link
                  key={servico.id}
                  to={`/${servico.slug}-${zona.slug}`}
                  className="px-3 py-1.5 bg-gray-100 hover:bg-blue-50 hover:text-blue-700 text-gray-700 rounded-full text-xs border border-gray-200 transition-colors"
                >
                  {servico.navTitle}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-white">
      <PageMeta
        title={`Zonas Atendidas — Ar Condicionado em ${cityName} e Arredores`}
        description={`Instalação, manutenção e venda de ar condicionado em ${zonas.map((z) => z.nome).slice(0, 6).join(', ')} e mais. Veja a página da sua zona.`}
        path="/zonas"
        jsonLd={jsonLd}
      />
      <Header />

      <section className="pt-28 pb-12 bg-gradient-to-b from-blue-50 to-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Zonas Atendidas
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Trabalhamos em {cityName} e nos concelhos envolventes. Cada zona tem a sua página,
            com o que muda tecnicamente naquele edificado.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <Grupo titulo="Concelhos" lista={concelhos} />
          <Grupo titulo="Zonas de Lisboa" lista={freguesias} />

          <div className="bg-blue-600 rounded-2xl p-8 text-center text-white">
            <h2 className="text-2xl font-bold mb-3">Não vê a sua zona?</h2>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Estas são as zonas com página própria, mas deslocamo-nos a mais localidades.
              Ligue-nos e confirmamos se chegamos aí.
            </p>
            <a
              href={`tel:${siteConfig.phone}`}
              onClick={handlePhoneClick}
              className="bg-white text-blue-700 hover:bg-gray-100 font-semibold py-3 px-8 rounded-lg transition-colors inline-flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              {siteConfig.phoneDisplay}
            </a>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50" id="orcamento">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <QuoteForm />
          </div>
        </div>
      </section>

      <FloatingWhatsApp />
      <Footer />
    </div>
  );
};

export default Zonas;
